<template>
  <div class="main-content">

    <!-- Section: home -->
    <section id="home" class="divider">
      <div class="container-fluid p-0">

        <!-- Slider Revolution Start -->
        <div id="home-slider" class="rev_slider_wrapper">
          <div class="rev_slider" data-version="5.0">
            <ul>

              <!-- SLIDE 1 -->
              <li data-index="rs-7" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut"
                data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0" data-fstransition="fade"
                data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Movement Flow"
                data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah31.jpg" alt="" data-bgposition="35% 55%" data-bgfit="cover"
                  data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-1"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-110'']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">BENVENUTA NEL MONDO DI MOVEMENT FLOW.
                </div>

                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-1"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-60'']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Ti insegnerò a prenderti cura di te a 360°
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-10'']"
                  data-fontsize="['22', '18']" data-lineheight="['50']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Insieme renderemo divertente e stimolante
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['30']"
                  data-fontsize="['22', '18']" data-lineheight="['50']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">ciò che prima risultava difficile e noioso.
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-5"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['100']"
                  data-fontsize="['90','64','54','24']" data-lineheight="['95']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><a class="btn btn-theme-colored"
                    style="font-size:18px" href="/category?Key=MovementFlow">Acquista</a>
                </div>
              </li>

              <!-- SLIDE 2 -->
              <li data-index="rs-1" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut"
                data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0" data-fstransition="fade"
                data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Movimento"
                data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah89.jpg" alt="" data-bgposition="center 70%" data-bgfit="cover"
                  data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-1"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-60'']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Il mio mondo ti aiuterà a trovare
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-10']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">L'equilibrio, la consapevolezza e la forza
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['40']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Necessari nella vita di tutti i giorni,
                  attravero il
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-3"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['100']"
                  data-fontsize="['90','64','54','24']" data-lineheight="['95']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span
                    class="text-theme-colored">MOVIMENTO</span>
                </div>
              </li>

              <!-- SLIDE 3 -->
              <li data-index="rs-2" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut"
                data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0" data-fstransition="fade"
                data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Healty e happy!"
                data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah10.jpg" alt="" data-bgposition="center 25%" data-bgfit="cover"
                  data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-1-layer-1"
                  data-x="['left']" data-hoffset="['30']" data-y="['middle']" data-voffset="['-110'']"
                  data-fontsize="['90','64','54','24']" data-lineheight="['95']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span class="text-theme-colored">SANO E IN
                    ARMONIA!</span>
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['left']" data-hoffset="['30']" data-y="['middle']" data-voffset="['0']"
                  data-fontsize="['30', '22']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">EQUILIBRIO E MODERAZIONE SONO LA CHIAVE DI
                  TUTTO.
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['left']" data-hoffset="['30']" data-y="['middle']" data-voffset="['40']"
                  data-fontsize="['30', '22']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">INSIEME COSTRUIREMO UN RAPPORTO SANO,
                  EQUILIBRATO CON IL CIBO.
                </div>

                <!-- LAYER NR. 2 -->
                <!-- <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['left']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['80']"
                  data-fontsize="['30', '22']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">PRENDITI CURA DI TE E GODITI IL VIAGGIO!
                </div> -->

              </li>

              <!-- SLIDE 4 -->
              <li data-index="rs-3" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut"
                data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0" data-fstransition="fade"
                data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="WORKOUT"
                data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah113.jpg" alt="" data-bgposition="center 30%" data-bgfit="cover"
                  data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-1"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['0']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">QUI TROVERAI DIVERSI PERCORSI CHE TI
                  AIUTERANNO
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['40']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">A REALIZZARE I TUOI OBIETTIVI
                </div>


                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['80']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">MA TUTTO DIPENDE DALLA TUA REALE MOTIVAZIONE
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" id="rs-3-layer-2"
                  data-x="['right']" data-hoffset="['30']" data-y="['middle']" data-voffset="['120']"
                  data-fontsize="['36', '24']" data-lineheight="['75']" data-width="none" data-height="none"
                  data-whitespace="nowrap" data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" data-splitin="none" data-splitout="none" data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">E DAL TUO IMPEGNO.
                </div>

                <!-- LAYER NR. 1 -->
                <!-- <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-3"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['190']"
                  data-fontsize="['90','64','54','24']"
                  data-lineheight="['95']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span class="text-theme-colored">INIZIAMO</span>
                </div> -->
              </li>


            </ul>
          </div>
        </div>
        <!-- Slider Revolution Ends -->
      </div>
    </section>

    <section id="trial" class="divider parallax  layer-overlay" data-parallax-ratio="0.7" v-if="!loggedIn">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  ISCRIVITI E AVRAI ACCESSO ALL'AREA PERSONALE CON UN <span class="text-theme-colored">PROGRAMMA
                    GRATUITO</span> PER 7 GIORNI
                </h3>
                <a class="btn btn-theme-colored" href="/subscribe">ISCRIVITI</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Categories -->
    <section id="categories">
      <div class="container" v-if="results != null && results.length > 0">

        <div class="messageHomePayPal" data-pp-message data-pp-style-layout="flex" data-pp-style-ratio="20x1"
          data-pp-style-color="black">
        </div>
        <div class="row mtli-row-clearfix p-20" id="dashboardPrograms">
          <div class="col-sm-4 pb-20" v-for="category in results" :key="category.id">
            <a :href="'/category?Key=' + category.UrlKey"
              class="class-item box-hover-effect effect1 mb-md-30 bg-lighter category-item">
              <div class="thumb mb-20">
                <img :alt="category.Image[0].alternativeText" :src="baseUrl + category.Image[0].url"
                  class="img-fullwidth">
              </div>
              <div class="content text-left flip p-25 pt-0">
                <h4 class="text-uppercase font-weight-800 line-bottom">{{ category.Title }}</h4>
                <p>{{ category.ShortDescription }}</p>
                <a class="btn-read-more btn-sm">Scopri</a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Categories -->
    <!-- <section id="callToAction" class="divider parallax layer-overlay"  data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10" style="text-align:center">                
                <video controls autoplay style="width:100%;">
                  <source src="/strapi/uploads/Sarah_insta_2_converted_medium_d0d3680d4e.mp4" type="video/mp4">                  
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Section: callToAction  -->
    <section id="callToAction" class="divider parallax  layer-overlay" data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  Per chi lo desidera è possibile accedere ad un <span class="text-theme-colored">programma</span>
                  specifico <span class="text-theme-colored">personalizzato</span>,<br />
                  strettamente cucito sui propri obiettivi ed esigenze.
                </h3>
                <div class="row equal mt-40">
                  <div class="col-md-5">
                    <img class="img-fullwidth" src="images/202208/Sarah04.jpg" alt="">
                  </div>
                  <div class="col-md-7">
                    <div v-if="!SentEmail">
                      <h3 class="mt-15 mb-10 mt-sm-30">Inviami un messaggio</h3>

                      <form id="contact_form" class="needs-validation" name="contact_form" @reset="resetContact" @submit="sendContact"
                        novalidate>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Nome <small>*</small></label>
                              <input name="form_name" class="form-control" type="text" placeholder="Nome"
                                v-model="Contact.Name" required>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Email <small>*</small></label>
                              <input name="form_email" class="form-control required email" type="email"
                                v-model="Contact.Email" placeholder="Email" required>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Oggetto <small>*</small></label>
                              <input name="form_subject" class="form-control required" type="text"
                                v-model="Contact.Subject" placeholder="Oggetto" required>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Telefono</label>
                              <input name="form_phone" class="form-control" type="text" v-model="Contact.Phone"
                                placeholder="Telefono">
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Messaggio <small>*</small></label>
                          <textarea name="form_message" class="form-control required" rows="5" v-model="Contact.Message"
                            placeholder="Messaggio" required></textarea>
                        </div>

                        <div class="row">
                          <div class="form-check col-md-12">
                            <input type="checkbox" required v-model="Contact.privacy" class="form-check-input"
                              id="chkPrivacy" />
                            <label class="form-check-label" for="chkPrivacy">Accetto le condizioni di privacy
                              <a class="text-theme-colored" target="_blank" href="/privacy">Leggi qui</a></label>
                          </div>
                          <div class="form-check col-md-12">
                            <input type="checkbox" v-model="Contact.condition" required class="form-check-input"
                              id="chkConditions" />
                            <label class="form-check-label" for="chkConditions">Accetto i termini e condizioni
                              <a class="text-theme-colored" target="_blank" href="/terms">Leggi qui</a></label>
                          </div>
                        </div>

                        <div class="row pt-10">
                          <div class="alert alert-danger" v-if="error">{{ error }}</div>
                        </div>

                        <div class="form-group">
                          <input name="form_botcheck" class="form-control" type="hidden" value="" />
                          <button type="submit" class="btn btn-dark btn-theme-colored btn-flat mr-5"
                            data-loading-text="Please wait...">Invia messaggio</button>
                          <button type="reset" class="btn btn-default btn-flat btn-theme-colored">Svuota</button>
                        </div>
                      </form>
                    </div>
                    <div class="vertical-center t-a-center" v-if="SentEmail">
                      <h3 class="mt-0 mb-10 mt-sm-30">Grazie per avermi contattata, ti risponderò il prima possibile</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Section: Categories -->
    <section id="reviews">

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-dark font-brooklyn-light t-a-center">
              COSA DICONO DI ME...
            </h3>
          </div>
        </div>



        <!-- https://tools.picsart.com/text/emojis/people/ -->

        <carousel :items="1" :margin="40" :nav="true"
          :navText="[`<i class='fa fa-chevron-left'></i>`, `<i class='fa fa-chevron-right'></i>`]"
          :responsive="{ 0: { items: 1, nav: true }, 600: { items: 2, nav: true } }" :dots="false">



          <div class="review-box">
            <div class="review-title">Grazie Sarah ❤️</div>
            <div class="review-description">
              Non è facile affidarsi a qualcuno che non si conosce...sopratutto iniziare un percorso online...ma è come se
              tu fossi sempre presente. Ti ho scelta tra tante e a distanza di un anno...lo farei ancora ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Mi sento meglio!!!</div>
            <div class="review-description">
              Mi sono accorta che rispetto agli allenamenti che facevo prima al box le mie gambe sono meno gonfie e i
              glutei si sono rimpolpati😅
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Sono passati 5 anni</div>
            <div class="review-description">
              Ciao Sarah...credo siano passati 5 anni...ma conservo ancora la maglia con molta cura, e la indosso con
              affetto perchè i bei percorsi e le belle persone rimangono sempre nel cuore ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Dopo la nostra chiacchierata</div>
            <div class="review-description">
              Il nostro confronto è stata una sorta di "medicina" per ripartire con ancora più volontà...Questo per
              esprimere la grande importanza di avere un rapporto diretto con la nostra coach...è davvero
              importante...L'allenamento è anche benessere mentale non solo fisico...e avere qualcuno che ti segue e ci
              tiene come te è "tanta roba"!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Adoro gli allenamenti</div>
            <div class="review-description">
              Tornando agli allenamenti stanno andando una bomba, mi piacciono ogni mese di più e inizia a vedere anche
              qualche muscoletto niente male ☺️ da un pò ho iniziato anche a correre e ho scoperto che mi paice davvero
              tanto!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title">Gestione allenamenti</div>
            <div class="review-description">
              Una cosa bellissima dei tuoi allenamenti è che puoi gestirli ed è una cosa che mi fa stare bene....se non ho
              tempo di fare tutto posso dividerli.
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ah Sarahhhh ieri i complimenti del fisioterapista a chi mi struttura gli allenamenti. Mai visto un addome
              tanto forte durante le terapie... oltre alla mobilità 🖐️😝
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Saraaaaaaaaaaaah<br />
              Ho iniziato il secondo mese del trimestrale! Queste schede mi piacciono ancora di più di primaaaa 🤩🤸‍♀️
              gli allenamenti sono stra vari, hanno dentro di tutto, non mi annoioooo, con la corsa sto facendo un po' di
              progressi forse 😅<br />
              Grazie grazie!<br />
              Devo impegnarmi a mandarti qualche video 🤞<br />
              Buona serata 😘
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ciao Sarah 😍<br />
              Bello sentirti... 🥰<br />
              Fino ad ora ho fatto 4 allenamenti, va molto bene, mi piace moltissimo perchè io insegno yoga e avevo
              bisogno proprio di un mix!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Sudo anche l'anima ma che bellezza ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>

          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Per come sono fatta fisicamente credo di non aver mai avuto le gambe così leggere e sgonfie in vita mia, era
              una cosa che non mi faceva sentire in pace e a disagio spesso, ho capito e accettato che non posso cambiarle
              ma posso prendermene cura e fare i movimenti che le fanno stare bene ma soprattutto a vedere le mie gambe
              non tanto per come sono ma per quello che mi possono far fare, forti e muscolose mi supportano quando faccio
              trail in salita, e senza di loro per come sono fatte non andrei da nessuna parte 😊<br />
              Grazie per i tuoi programmi 😘
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>

          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ciao!!! Benissimo Sarah 😄 sto continuando ad essere costante e non mi pesa per niente anzi sono tornata
              finalmente a non vedere l'ora di allenarmi. <br><br>
              Sto seguendo gli allenamenti del box ma i tuoi esercizi di mobilità non li ho mai mollati!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

        </carousel>

      </div>
    </section>


    <!-- Section: Gallery -->
    <section id="gallery" class="divider parallax layer-overlay" v-if="gallery && gallery.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Gallery Grid -->
            <div class="gallery-isotope grid-3 masonry gutter-small clearfix" data-lightbox="gallery">

              <!-- Portfolio Item Start -->
              <div class="gallery-item" v-for="galleryImg in gallery" :key="galleryImg.id">
                <a :href="baseUrl + galleryImg.Image.url" data-lightbox="gallery-item" :title="galleryImg.Title"><img
                    :src="baseUrl + galleryImg.Image.url" alt=""></a>
              </div>
              <!-- Portfolio Item End -->
            </div>
            <!-- End Portfolio Gallery Grid -->
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<style scoped>
.owl-prev,
.owl-next {
  font-size: 30px;
  color: #4CAF50;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 10px;
  transition: background 0.3s ease;
}

.owl-prev:hover,
.owl-next:hover {
  background: #4CAF50;
  color: #fff;
}

.owl-prev {
  left: -40px;
  /* Spostamento a sinistra */
}

.owl-next {
  right: -40px;
  /* Spostamento a destra */
}

a.class-item {
  display: block;
}

.messageHomePayPal {
  margin-left: 15px;
  margin-right: 15px;
}

#categories {
  background-color: #e0e0e0;
}

#callToAction h3 {
  font-size: 22px;
}

#callToAction {
  background-color: #f5f5f5;
}

@media only screen and (max-width: 768px) {
  #callToAction h3 {
    font-size: 18px;
  }
}

.review-box {
  border: 1px solid #ddd;
  border-left: 5px solid #4CAF50;
  padding: 20px;
  margin: 20px auto;
  max-width: 600px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  font-family: 'Arial', sans-serif;
  border-radius: 8px;
  position: relative;
}

.review-title {
  font-size: 1.2em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.review-description {
  font-size: 1em;
  color: #555;
  margin-bottom: 15px;
}

.review-source {
  font-size: 0.9em;
  color: #888;
  text-align: right;
}

.owl-carousel {
  position: relative;
}


.review-source i {
  color: #25D366;
  /* Colore ufficiale WhatsApp */
  margin-right: 5px;
}

.form-check-input {
  margin-right: 0.5rem;
  position: relative;
  top: 5px;
  width: 1.2rem;
  height: 1.2rem;
}
</style>

<script>
import axios from "axios";
import carousel from "vue-owl-carousel";
import { THEMEMASCOT } from "../../public/js/custom.js";

export default {
  name: "Home",
  components: {
    carousel
  },
  data() {
    return {
      SentEmail: false,
      error: "",
      Contact: {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      },
      results: [],
      baseUrl: process.env.VUE_APP_API_URL,
      gallery: [],
      loggedIn: !(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == "")
    };
  },
  methods: {
    resetContact: function () {
      this.error = "";
      this.Contact = {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      };
    },
    sendContact: function () {

      this.error = "";

      if (
        !this.Contact.privacy || !this.Contact.condition) {
        this.error = "Accetta privacy e condizioni";
        return;
      }

      var form = document.getElementById('contact_form');
      if (form.checkValidity()) {
        axios.post(process.env.VUE_APP_API_URL + "/utility/contactme", this.Contact).then(response => {
          this.SentEmail = response.data.ok;
        });
      }
    }
  },
  mounted() {

    var form = document.getElementById('contact_form');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      form.classList.add('was-validated');
    }, false);

    axios.get(process.env.VUE_APP_API_URL + "/categories?IsVisible=true").then(response => {
      this.results = response.data;
      THEMEMASCOT.slider.init();
    });

    axios.get(process.env.VUE_APP_API_URL + "/home-galleries").then(response => {
      this.gallery = response.data;
      console.log("Gallery:", this.gallery);
      THEMEMASCOT.widget.init();
    });
  }
};
</script>
